module.exports = __webpack_public_path__ + "media/entities/2318-1633f02a.png";